import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from '../../../../common/services/Report.service';
import { moment } from '../../../../../../node_modules/ngx-bootstrap/chronos/test/chain';
import { TicketService } from '../../../../common/services/Ticket.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { CommentService } from '../../../../common/services/Comment.service';
import { UserService } from '../../../../common/services/User.service';
import { GroupService } from 'app/common/services/Group.service';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'icontact-dashboad',
  templateUrl: 'dashboard.template.html',
  styleUrls: ['dashboard.component.css'],
  providers: [ReportService, TicketService, CommentService, UserService, GroupService],
})
export class DashboardComponent implements OnInit {
  public modelFilter: any = {
    source: '-1',
  };
  public summary: any = {};
  public statusTicket: any = [];
  public options: any;
  public user: any = {};
  public list: any = [];
  public page_size = 10;
  public currentPage = 1;
  totalItem: any = 0;
  totalPage: any = 0;
  public title: any = '';
  public filter: any = [{}];
  public allSources: any = [];
  public view_type: any = 'all';
  public detailTicket: any = {};
  public quick: any;
  public isOpenCheckboxHeader = false;
  public allGroup: any = [];
  public ticketCols: any = [
    {
      code: 'code',
      title: 'Phiếu Ghi',
      display: true,
      sort_field: 'code.keyword',
    },
    {
      code: 'subject',
      title: 'Chủ đề',
      display: true,
      sort_field: 'subject.keyword',
    },
    {
      code: 'request',
      title: 'Người yêu cầu',
      display: true,
      sort_field: 'requester_id',
    },
    {
      code: 'assign_agent',
      title: 'Chuyên viên',
      display: true,
      sort_field: 'assign_agent_id',
    },
    {
      code: 'source',
      title: 'Nguồn',
      display: true,
      sort_field: 'source.keyword',
    },
    {
      code: 'status',
      title: 'Trạng thái',
      display: true,
      sort_field: 'status',
    },
    {
      code: 'duedate',
      title: 'Thời hạn xử lý',
      display: true,
      sort_field: 'duedate',
    },
    {
      code: 'updated_at',
      title: 'Thời gian cập nhật',
      display: true,
      sort_field: 'updated_at',
    },
  ];
  public sort_field = 'updated_at';
  public sort_type = false;

  constructor(
    private reportService: ReportService,
    private ticketService: TicketService,
    private socketService: SocketService,
    private toastr: ToastrService,
    private commentService: CommentService,
    private userService: UserService,
    private groupService: GroupService,
    private router: Router
  ) {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.sort_field = localStorage.getItem('sort_field') ? localStorage.getItem('sort_field') : this.sort_field;
    this.sort_type = JSON.parse(localStorage.getItem('sort_Type'))
      ? JSON.parse(localStorage.getItem('sort_Type'))
      : this.sort_type;
    if (this.sort_field == 'requester_id' || this.sort_field == 'assign_agent_id') {
      this.sort_field = 'updated_at';
    }
    for (let i = 0; i < this.ticketCols.length; i++) {
      this.ticketCols[i].display = localStorage.getItem('show_' + this.ticketCols[i].code) == 'false' ? false : true;
    }
    this.statusTicket = [];
    this.title = 'Tất cả ticket';
    this.filter = [
      {
        key: 'status',
        condition: 'nin',
        value: [],
      },
    ];
    this.loadFilter();
    this.allSources = [
      { id: '-1', text: '- Tất cả -' },
      { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
      { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
      { id: 'chat', text: 'Tin nhắn web' },
      { id: 'hand', text: 'Thêm mới' },
      { id: 'zalo', text: 'Zalo' },
      { id: 'email', text: 'Email' },
      { id: 'facebook', text: 'Kênh Facebook' },
    ];
  }

  getAllGroup() {
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const groupList = [];
      groupList.push({
        id: 'all',
        text: '--Chọn--',
      });

      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allGroup = groupList;
    });
  }

  loadFilter() {
    const data = {};
    if (this.modelFilter.source && this.modelFilter.source != '-1') {
      data['source'] = this.modelFilter.source;
    }
    this.reportService.summary(data).subscribe(res => {
      this.summary = res.data;
      this.options = {
        chart: { type: 'pie' },
        title: { text: 'Tình trạng ticket' },
        series: [
          {
            name: 'Ticket',
            colorByPoint: true,
            data: [
              {
                name: 'Đang mở: ' + this.summary.open,
                y: this.summary.open,
              },
              {
                name: 'Đã đóng: ' + this.summary.close,
                y: this.summary.close,
              },
              {
                name: 'Đã xử lý: ' + this.summary.solved,
                y: this.summary.solved,
              },
              {
                name: 'Đang xử lý: ' + this.summary.doing,
                y: this.summary.doing,
              },
            ],
          },
        ],
      };
    });
    this.loadData({ filters: JSON.stringify(this.filter) });
    this.loadQuickSummary();
  }

  loadQuickSummary() {
    this.reportService.quickSummary().subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.quick = res.data;
      }
    });
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    delete request.desc;
    delete request.asc;
    if (!this.sort_type) {
      request['sort_by'] = this.sort_field + ':desc';
    } else {
      request['sort_by'] = this.sort_field + ':asc';
    }

    if (this.view_type == 'filter') {
      this.ticketService
        .listByFilter(request)
        .toPromise()
        .then(
          res => {
            if (res.status == 200 && res.error == false) {
              this.list = res.data.tickets;
              this.list.forEach(ticket => {
                ticket.duedate_warning = 0;
                ticket.backgroundColor = 'white';
                if (ticket.status == 1 || ticket.status == 2 || ticket.status == 4) {
                  if (ticket.duedate) {
                    if (
                      ticket.duedate < moment().add('+1', 'days').format('YYYY-MM-DD HH:mm') &&
                      ticket.duedate > moment().format('YYYY-MM-DD HH:mm')
                    ) {
                      ticket.duedate_warning = 1; // sap het han
                      ticket.backgroundColor = '#ecaf64';
                    } else if (ticket.duedate < moment().format('YYYY-MM-DD HH:mm')) {
                      ticket.duedate_warning = 2; // het han
                      ticket.backgroundColor = '#f96868';
                    }
                  }
                }
                if (ticket.duedate) {
                  ticket.duedate = moment(ticket.duedate).format('YYYY-MM-DD HH:mm');
                }
              });
              this.totalItem = res.data.total;
              const pageString = (this.totalItem / this.page_size).toString();
              const pageSplit = pageString.split('.');
              let last: any;
              let totalpage = parseInt(pageSplit[0]);
              if (pageSplit.length > 1) {
                last = pageSplit[1];
                if (parseInt(last) > 0) {
                  totalpage++;
                }
              }
              this.totalPage = totalpage;
            }
          },
          err => {
            this.list = [];
          }
        );
    } else {
      this.ticketService
        .list(request)
        .toPromise()
        .then(
          res => {
            if (res.status == 200 && res.error == false) {
              this.list = res.data.tickets;
              this.list.forEach(ticket => {
                ticket.duedate_warning = 0;
                ticket.backgroundColor = 'white';
                if (ticket.status == 1 || ticket.status == 2 || ticket.status == 4) {
                  if (ticket.duedate) {
                    if (
                      ticket.duedate < moment().add('+1', 'days').format('YYYY-MM-DD HH:mm') &&
                      ticket.duedate > moment().format('YYYY-MM-DD HH:mm')
                    ) {
                      ticket.duedate_warning = 1; // sap het han
                      ticket.backgroundColor = '#ecaf64';
                    } else if (ticket.duedate < moment().format('YYYY-MM-DD HH:mm')) {
                      ticket.duedate_warning = 2; // het han
                      ticket.backgroundColor = '#f96868';
                    }
                  }
                }
                if (ticket.duedate) {
                  ticket.duedate = moment(ticket.duedate).format('YYYY-MM-DD HH:mm');
                }
              });
              this.totalItem = res.data.total;
              const pageString = (this.totalItem / this.page_size).toString();
              const pageSplit = pageString.split('.');
              let last: any;
              let totalpage = parseInt(pageSplit[0]);
              if (pageSplit.length > 1) {
                last = pageSplit[1];
                if (parseInt(last) > 0) {
                  totalpage++;
                }
              }
              this.totalPage = totalpage;
            }
          },
          err => {
            this.list = [];
          }
        );
    }
  }

  openTicket(ticket: any) {
    this.ticketService.find(ticket._id).subscribe(rs => {
      const _ticket = rs.data;
      _ticket['_id'] = ticket._id;
      this.userService
        .find({ _id: ticket.requester_id })
        .toPromise()
        .then(res => {
          if (res.status == 200 && res.error == false) {
            _ticket.request = res.data;
            this.socketService.opentab(_ticket, 'ticket', 'edit');
          }
        });
    });
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData({ filters: JSON.stringify(this.filter) });
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData({ filters: JSON.stringify(this.filter) });
        }
      }
    }
  }

  hover(item) {
    this.detailTicket = item;
    this.commentService
      .list({
        where: JSON.stringify({ ticket_id: this.detailTicket._id }),
        limit: 1,
      })
      .subscribe(res => {
        if (res.status == 200 && res.error == false && res.data.comments) {
          this.detailTicket['lastest_comment'] = res.data.comments[0] ? res.data.comments[0] : null;
        }
      });
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  public changeSource(e: any): void {
    if (this.modelFilter['source'] != e.value) {
      this.modelFilter['source'] = e.value;
      this.loadFilter();
      this.navigateTo(this.view_type);
    } else {
      this.loadFilter();
      this.navigateTo(this.view_type);
    }
  }

  navigateFilter(filter: any) {
    this.title = filter.name;

    this.filter = [filter];
    this.view_type = 'filter';
    this.currentPage = 1;
    this.loadData({ filters: JSON.stringify(this.filter) });
  }

  addFilterSourceDetail(filter) {
    if (this.modelFilter.source && this.modelFilter.source != -1) {
      filter.push({
        key: 'source_detail',
        condition: '=',
        value: this.modelFilter.source,
      });
    }
    return filter;
  }
  navigateTo(type: any) {
    this.filter = [{}];
    this.currentPage = 1;

    this.view_type = type;
    switch (type) {
      case 'all': {
        this.title = 'Tất cả ticket';
        this.filter = [
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'campaign': {
        this.title = 'Ticket chiến dịch của tôi';
        this.filter = [
          {
            key: 'assign_agent_id',
            condition: '=',
            value: this.user._id,
          },
          {
            key: 'campaign_id',
            condition: 'notnull',
          },
          {
            key: 'status',
            condition: 'in',
            value: [1, 2, 4],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'miss': {
        this.title = 'Ticket nhỡ';
        this.filter = [
          {
            key: 'call_status',
            condition: '=',
            value: 'miss',
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'not_assign': {
        this.title = 'Ticket chưa gán';
        this.filter = [
          {
            key: 'assign_agent_id',
            condition: '=',
            value: null,
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'assign_me': {
        this.title = 'Ticket gán cho bạn';
        this.filter = [
          {
            key: 'assign_agent_id',
            condition: '=',
            value: this.user._id,
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'doing': {
        this.title = 'Ticket đang xử lý';
        this.filter = [
          {
            key: 'status',
            condition: '=',
            value: 2,
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'follow': {
        this.title = 'Ticket đang theo dõi';
        this.filter = [
          {
            key: 'follow_users',
            condition: '=',
            value: this.user._id,
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'ticket_campaign': {
        this.title = 'Ticket chiến dịch của tôi';
        this.filter = [
          {
            key: 'ticket_campaign',
            condition: '=',
            value: this.user._id,
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'solved': {
        this.title = 'Ticket đã xử lý';
        this.filter = [
          {
            key: 'status',
            condition: '=',
            value: 3,
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'open': {
        this.title = 'Ticket đang mở';
        this.filter = [
          {
            key: 'status',
            condition: 'in',
            value: [1, 2, 4],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'close': {
        this.title = 'Ticket đã đóng';
        this.filter = [
          {
            key: 'status',
            condition: '=',
            value: 5,
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'near_duedate': {
        this.title = 'Ticket sắp hết hạn';
        this.filter = [
          {
            key: 'duedate',
            condition: 'lt',
            value: new Date(Date.now() + 86400000).toISOString(),
          },
          {
            key: 'duedate',
            condition: 'gt',
            value: new Date().toISOString(),
          },
          {
            key: 'status',
            condition: 'in',
            value: [1, 2, 4],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'over_duedate': {
        this.title = 'Ticket đã hết hạn';
        this.filter = [
          {
            key: 'duedate',
            condition: 'lt',
            value: new Date().toISOString(),
          },
          {
            key: 'status',
            condition: 'in',
            value: [1, 2, 4],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'miss_call': {
        this.title = 'Ticket nhỡ';
        this.filter = [
          {
            key: 'call_status',
            condition: '=',
            value: 'miss',
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'reject_call': {
        this.title = 'Ticket từ chối cuộc gọi';
        this.filter = [
          {
            key: 'call_status',
            condition: '=',
            value: 'reject',
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
      case 'answer_call': {
        this.title = 'Ticket cuộc gọi thành công';
        this.filter = [
          {
            key: 'call_status',
            condition: '=',
            value: 'answer',
          },
          {
            key: 'status',
            condition: 'nin',
            value: [],
          },
        ];
        this.filter = this.addFilterSourceDetail(this.filter);
        break;
      }
    }
    this.loadData({ filters: JSON.stringify(this.filter) });
  }

  redirectUpdate(ticket_id) {
    // this.isAdd = false;
    // this.isUpdate = true;
    this.ticketService
      .find(ticket_id)
      .toPromise()
      .then(res => {
        const _ticket = res.data;
        console.log('TST', ticket_id, res);
        this.socketService.updateHandTicket(_ticket);
      });
  }

  navigateToDetail(type: any) {
    switch (type) {
      case 'all': {
        this.router.navigate(['/tickets'], { queryParams: {} });
        break;
      }
      case 'not_assign': {
        this.router.navigate(['/tickets'], {
          queryParams: { assign_user_ids: 0 },
        });
        break;
      }
      case 'assign_me': {
        this.router.navigate(['/tickets'], {
          queryParams: { assign_user_ids: this.user.id },
        });
        break;
      }
      case 'doing': {
        this.router.navigate(['/tickets'], { queryParams: { status: 2 } });
        break;
      }
      case 'solved': {
        this.router.navigate(['/tickets'], { queryParams: { status: 3 } });
        break;
      }
      case 'open': {
        this.router.navigate(['/tickets'], { queryParams: { status: '1,4' } });
        break;
      }
      case 'close': {
        this.router.navigate(['/tickets'], { queryParams: { status: 5 } });
        break;
      }
      case 'miss_call': {
        this.router.navigate(['/tickets'], {
          queryParams: { source: 'call', receiver_ids: 0 },
        });
        break;
      }
      case 'expired': {
        this.router.navigate(['/tickets'], {
          queryParams: {
            date_type: 'exec_date',
            to: moment().format('YYYY-MM-DD HH:mm'),
          },
        });
        break;
      }
    }
  }

  changedHeaderCheckbox(e: any, code) {
    const index = this.ticketCols.findIndex(el => el.code == code);
    if (e.target.checked) {
      this.ticketCols[index].display = true;
    } else {
      this.ticketCols[index].display = false;
    }
    localStorage.setItem('show_' + this.ticketCols[index].code, this.ticketCols[index].display);
  }

  sortTable(field) {
    if (field.sort_field != 'requester_id' && field.sort_field != 'assign_agent_id') {
      this.sort_field = field.sort_field;
      localStorage.setItem('sort_field', field.sort_field);
      this.sort_type = !this.sort_type;
      localStorage.setItem('sort_type', this.sort_type.toString());
      this.loadFilter();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/dashboard/dashboard.component.ts